import { isWeb } from "@helpers/platform";
import { Appbar } from "react-native-paper";
import { usePrinting } from "../../hooks/usePrinting";

export default function PrintButton() {
	const { handlePrint } = usePrinting();

	if (!isWeb) {
		return null;
	}

	return <Appbar.Action icon="printer-outline" onPress={handlePrint} />;
}
